import gql from 'graphql-tag';

export const dayFragment = gql`
  fragment AdminDayData on AdminDay {
    uuid
    day
    content
  }
`;
